export const getSearchParam = (parameter = "", searchParams) => {
  return searchParams.get(parameter)
}
